import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Diagnose from 'Components/Diagnose';
import { Box, Flex } from 'Components/Base';
import Loading from 'Components/Loading';
import getConfig from 'Util/Config';

import { isLoading } from '../../Redux/user-profile/selectors';

const HealthCheck = ({ isLoading }) => {
  const { timeResponse } = getConfig();

  if (isLoading) {
    return (
      <Flex justifyContent={'center'} alignItems={'center'} height={'100vh'}>
        <Loading />
      </Flex>
    );
  }

  return (
    <Box backgroundColor="#F5F7F9" p={{ _: '24px', md: '60px' }}>
      <Diagnose timeResponse={timeResponse} />
    </Box>
  );
};

HealthCheck.propTypes = {
  isLoading: PropTypes.bool,
};

export default connect((state) => ({
  isLoading: isLoading(state),
}))(HealthCheck);
